import App from './App.container';

export default App;



// WEBPACK FOOTER //
// ./src/ui/index.js